import React, { useMemo, useState } from 'react'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
  Button,
} from '@material-ui/core'
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import moment from 'moment'
import { deleteComment, updateComment } from '../api'

const CommentsList = ({ comments, setComments, ticketId, type }) => {
  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginTop: 20,
      }}
    >
      <TableComments
        comments={comments}
        setComments={setComments}
        ticketId={ticketId}
        type={type}
      />
    </Box>
  )
}
export default CommentsList

const TableComments = ({ comments, setComments, ticketId, type }) => {
  const [editCommentId, setEditCommentId] = useState(null)
  const [editCommentText, setEditCommentText] = useState('')
  const [isUpdating, setIsUpdating] = useState(false)

  const sortedComments = useMemo(() => {
    return [...comments].sort(
      (a, b) => new Date(b.created) - new Date(a.created)
    )
  }, [comments])

  const handleDelete = async (commentId) => {
    const res = await deleteComment(ticketId, type, commentId)
    if (res.status === 200) {
      setComments((prevComments) =>
        prevComments.filter((comment) => comment.id !== commentId)
      )
    }
  }

  const handleEdit = (comment) => {
    setEditCommentId(comment.id)
    setEditCommentText(comment.comment)
  }

  const handleEditSave = async () => {
    setIsUpdating(true)
    try {
      const res = await updateComment(
        ticketId,
        type,
        editCommentId,
        editCommentText
      )
      if (res?.status === 200) {
        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment.id === editCommentId
              ? {
                  ...comment,
                  comment: editCommentText,
                  seen: true,
                }
              : comment
          )
        )
        setEditCommentId(null)
        setEditCommentText('')
      }
    } catch (error) {
      console.error('Failed to update comment:', error)
    } finally {
      setIsUpdating(false)
    }
  }

  const handleEditCancel = () => {
    setEditCommentId(null)
    setEditCommentText('')
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nom</TableCell>
            <TableCell>Commentaire</TableCell>
            <TableCell>Le</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedComments?.length ? (
            sortedComments.map((comment) => (
              <TableRow key={comment.id}>
                <TableCell>{comment.firstName}</TableCell>
                <TableCell>{comment.comment}</TableCell>
                <TableCell>
                  {moment(comment.created).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell>
                  <Tooltip title="Éditer">
                    <IconButton onClick={() => handleEdit(comment)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Supprimer">
                    <IconButton onClick={() => handleDelete(comment.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} align="center">
                Aucun commentaires trouvé
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <Dialog
        open={editCommentId !== null}
        onClose={handleEditCancel}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Éditer le commentaire</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Commentaire"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={editCommentText}
            onChange={(e) => setEditCommentText(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditCancel} color="primary">
            Annuler
          </Button>
          <Button
            onClick={handleEditSave}
            color="primary"
            variant="contained"
            disabled={isUpdating || editCommentText.trim() === ''}
          >
            {isUpdating ? 'Enregistrement...' : 'Enregistrer'}
          </Button>
        </DialogActions>
      </Dialog>
    </TableContainer>
  )
}
